import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import Button from 'components/Button';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TeamsList from './common/TeamsList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AudienceTeamOrAllField(_ref) {
  var onAddTeams = _ref.onAddTeams,
    onRemoveTeam = _ref.onRemoveTeam,
    onSetEveryone = _ref.onSetEveryone,
    teams = _ref.teams,
    horizontal = _ref.horizontal,
    label = _ref.label,
    description = _ref.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(FormField, {
    as: "fieldset",
    label: label || t('property_audience'),
    horizontal: horizontal,
    children: teams.length === 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Pill, {
        as: "p",
        children: t('state_everyone')
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
        mt: "xs",
        icon: "plus",
        onClick: onAddTeams,
        size: "medium",
        children: t('actions_select_teams')
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [description && /*#__PURE__*/_jsx(Flag, {
        token: /*#__PURE__*/_jsx(Icon, {
          vAlign: true,
          name: "info",
          dimmed: true
        }),
        spacing: "xs",
        my: "xs",
        children: /*#__PURE__*/_jsx(Text, {
          children: description
        })
      }), /*#__PURE__*/_jsx(TeamsList, {
        teams: teams,
        onRemoveTeam: onRemoveTeam
      }), /*#__PURE__*/_jsx(Box, {
        mt: "xs",
        children: /*#__PURE__*/_jsxs(InlineList, {
          spacing: "xs",
          top: "xs",
          children: [/*#__PURE__*/_jsx(Button, {
            icon: "edit",
            onClick: onAddTeams,
            size: "medium",
            children: t('actions_edit_teams')
          }), /*#__PURE__*/_jsx(Button, {
            size: "medium",
            onClick: onSetEveryone,
            children: t('actions_set_audience_to_everyone')
          })]
        })
      })]
    })
  });
}
export default AudienceTeamOrAllField;